import {
  ActivatedRouteSnapshot,
  GuardResult,
  MaybeAsync,
} from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { ValidateEmailHashService } from '@flexyoo/auth';

@Injectable()
export class ChoosePasswordGuard {
  private readonly validateEmailHashService = inject(ValidateEmailHashService);

  public canActivate(route: ActivatedRouteSnapshot): MaybeAsync<GuardResult> {
    const params = route.queryParams;

    return this.validateEmailHashService.validate(
      params.email,
      params.hash,
      params.name,
      'choose'
    );
  }
}
